import axios from "axios";
import { FormTemplate } from "../models/FormTemplate";
import { Response } from "../../../shared/models/Response";
import { QuerySend } from "../../../shared/models/FormQuerySend";
import { DataResponse } from "../models/FormDataResponse";
import { FormTemplateData } from "@/modules/FormTemplate/models/FormTemplateData";
import { FormStatus } from "../models/FormStatus";
import { QuerySearchFormTemplate } from "../models/QuerySearchFormTemplate ";
import { FormStatusResponse } from "../models/FormStatusResponse";

export class FormTemplateService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/form-templates`;
  }

  async addFormTemplate(
    formTemplate: FormTemplate
  ): Promise<Response<string | void>> {
    return (await axios.post(`${this.baseUrl}/add-form`, formTemplate)).data;
  }
  async checkIfFormTemplateExist(name: string): Promise<Response<void>> {
    return (
      await axios.get(`${this.baseUrl}/check-exist`, {
        params: { formName: name }
      })
    ).data;
  }

  async getFormTemplateIdByName(name: string): Promise<Response<string>> {
    return (
      await axios.get(`${this.baseUrl}/get-formTemplate-id`, {
        params: { formName: name }
      })
    ).data;
  }

  async getFormTemplateWithFilters(
    query: QuerySend
  ): Promise<Response<DataResponse>> {
    const res = await axios.get(`${this.baseUrl}/filters`, { params: query });
    return res.data;
  }
  async getFormTemplateWithFiltersArray(
    query: QuerySearchFormTemplate
  ): Promise<Response<FormStatusResponse>> {
    const res = await axios.get(`${this.baseUrl}/filter-arrays`, {
      params: query
    });
    return res.data;
  }
  async getFormTemplateById(
    id: string
  ): Promise<Response<FormTemplate | void>> {
    return (await axios.get(`${this.baseUrl}/${id}`)).data;
  }

  async updateFormTemplate(
    id: string,
    formTemplate: FormTemplate
  ): Promise<Response<void>> {
    return (await axios.put(`${this.baseUrl}/${id}`, formTemplate)).data;
  }

  async updateStateFormTemplateById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async getFormTemplateSchemaById(
    id: string
  ): Promise<Response<FormTemplateData | void>> {
    return (await axios.get(`${this.baseUrl}/schema/${id}`)).data;
  }

  async getFormTempsByIdsArray(
    query: QuerySend
  ): Promise<Response<Array<FormStatus>>> {
    const serviceURL = `${this.baseUrl}/by-array`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async deleteFormTemp(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async getAllActiveFormTemplates(): Promise<Response<FormStatus[]>> {
    const res = await axios.get(
      `${this.baseUrl}/get-all-active-form-templates`
    );
    return res.data;
  }
}
